module.exports = __webpack_public_path__ + "img/hr201files.b08fcab3.jpg";